import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";

import { FormInfo } from "./FormInfo";

const mapStateToProps = (state: FullFormState) => ({
    formInfo: state.settings.formInfo,
});

export const FormInfoContainer = connect(mapStateToProps)(FormInfo);
